import { Component, OnInit, AfterViewInit } from '@angular/core';
import { NgRedux, select } from '@angular-redux/store';
import { IAppState } from '../../reducers/root.reducer';
import { OlMapService } from 'vitojs';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import * as ol from 'openlayers';
import {LayerActions, LayerState} from '../../reducers/layer.reducer';
import { ActivatedRoute } from '@angular/router';
import { InternalFormsSharedModule } from '../../../../node_modules/@angular/forms/src/directives';


@Component({
	selector: 'app-main',
	templateUrl: './main.component.html',
	styleUrls: ['./main.component.scss'],
})

export class MainComponent implements OnInit {

	@select() layergroup: Observable<LayerState>;

	config: any;

	constructor(private ngRedux: NgRedux<IAppState>, private mapService: OlMapService) {
	}

	ngOnInit() {
	  this.ngRedux.dispatch({type: LayerActions.INIT});
		const interactions: olx.interaction.DefaultsOptions = {
			pinchRotate: false
		};
		this.config = {
			interactions: interactions
		};
	}
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Angular_wig_cropmap_master/src/app/components/main/main.component.ts